export const ORDER_ISSUERS_FETCH_INIT = 'ORDER_ISSUERS_FETCH_INIT';
export const ORDER_ISSUERS_FETCH_SUCCESS = 'ORDER_ISSUERS_FETCH_SUCCESS';
export const ORDER_ISSUERS_FETCH_ERROR = 'ORDER_ISSUERS_FETCH_ERROR';

export const ORDER_ISSUERS_POST_INIT = 'ORDER_ISSUERS_POST_INIT';
export const ORDER_ISSUERS_POST_SUCCESS = 'ORDER_ISSUERS_POST_SUCCESS';
export const ORDER_ISSUERS_POST_ERROR = 'ORDER_ISSUERS_POST_ERROR';

export const ORDER_ISSUERS_RESET = 'ORDER_ISSUERS_RESET';
